/**
 * Created by Carsten Bühler
 * User: CBuehler on 11.02.2016
 * Copyright: xdot GmbH 2015
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { AppContext } from 'plugin/liferay-widgets-react-web';
import ModalActions from '../actions/ModalActions';
import TitleActions from '../actions/TitleActions';
import { getTitleStore } from '../stores/StoreFactory';

const TitleStore = getTitleStore(AppContext);

class BusinessObjectLink extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.state.title = this.props.title || TitleStore.getTitleFromKey(this.props.className + '-' + this.props.classPK);
        this.state.isActive = this.props.isActive !== undefined ? this.props.isActive : true;
        this.state.isVisible = this.props.isVisible !== undefined ? this.props.isVisible : true;
    }

    componentDidMount() {
        this.removeListener = TitleStore.addListener(this.titlesChanged.bind(this));
        //Fetch the title, if no customtitle was set via props.
        if (!this.state.title) {
            this.requestTitle();
        }
    }

    requestTitle() {
        const titleKey = this.props.className + '-' + this.props.classPK;
        TitleActions.missingTitles([ titleKey ]);
    }

    componentDidUpdate(prevProps, prevState) {
        if (!(prevProps.className === this.props.className && prevProps.classPK === this.props.classPK)) {
            const titleFromStore = TitleStore.getTitleFromKey(this.props.className + '-' + this.props.classPK);
            if (!titleFromStore) {
                this.requestTitle();
            } else {
                this.setState({ title: titleFromStore });
            }
        }
    }

    titlesChanged() {
        const newTitle = this.props.title || TitleStore.getTitleFromKey(this.props.className + '-' + this.props.classPK);
        if (this.state.title !== newTitle) {
            this.setState({
                title: newTitle
            });
        }
    }

    openDetailsModal(className, classPK, e) {
        ModalActions.showModal(className, {
            id: classPK
        }, false, undefined, { contextId: this.context && this.context.contextId });
        e.preventDefault();
        e.stopPropagation();
    }

    componentWillUnmount() {
        if (this.removeListener) {
            this.removeListener.remove();
        }
    }

    render() {
        const { buttonProps = {}, inline = true } = this.props;
        return (
            <a
                className={`btn btn-outline-primary btn-sm business-object-link ${inline ? 'business-object-link--inline' : ''} ${!this.state.isActive ? 'business-object-link-error' : ''}  ${!this.state.isVisible ? 'business-object-link-not-visible' : ''} `}
                title={this.state.title}
                onClick={this.openDetailsModal.bind(this, this.props.className, this.props.classPK)}
                data-object-type={this.props.className}
                {...buttonProps}
            >
                {this.state.title ? this.state.title : '#' + this.props.className + '-' + this.props.classPK}
            </a>
        );
    }

}

BusinessObjectLink.propTypes = {
    className: PropTypes.string.isRequired,
    classPK: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]).isRequired,
    title: PropTypes.string,
    /* indicates if object "exists", false = deleted(=deactivated))*/
    isActive: PropTypes.bool,
    /* indicates if object is visible because either it is shared or it is in same site */
    isVisible: PropTypes.bool,
    buttonProps: PropTypes.object,
    inline: PropTypes.bool,
};

BusinessObjectLink.contextTypes = {
    contextId: PropTypes.string
};

export default BusinessObjectLink;



// WEBPACK FOOTER //
// ./js/components/BusinessObjectLink.jsx